module.exports = __webpack_public_path__ + "first-200_signature.jpg?6a642fd6f4cc30d29b4a50ebf931c897";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-200_signature.jpg
// module id = 491
// module chunks = 0